module.exports = __webpack_public_path__ + "img/0S6A9515.57ae4dc4.jpg";